<template>
    <div class="container">
        <div class="row">



            <div class="col-md-8">

                <div class="prebok">Prebook Your Meal and Save More! <button type="button" class="tibtn" @click="showFnB=!showFnB">{{showFnB?'Not now':'Show menu'}}</button> </div>
                
                <div class="tabset" v-if="showFnB">
                    <span @click="showProducts(null)">
                        <input type="radio" id="tab0" value="0" :checked="all">
                        <label for="tab0" class="bornon">All</label>
                    </span>
                    <span v-for="(category, categoryId) in categories" :key="categoryId">
                        <input type="radio" :id="'tab' + categoryId" :value="categoryId" v-model="selectedCategory"
                            @change="showProducts(categoryId)">
                        <label :for="'tab' + categoryId" class="bornon">{{ category.name }}</label></span>

                    <div class="tab-panels">
                        <section id="marzen" class="tab-panel" style="padding-bottom: 0px;">

                            <div class="row manhe">
                                <div class="col-4 col-md-3" v-for="(prdct, productId) in selectedCategoryProducts"
                                    :key="productId">
                                    <div>
                                        <div> <img :src="uploads+'product/'+(prdct.img||'noimg.jpg')" > </div>
                                        <div class="foonam"> {{ prdct.pdtname }}</div>
                                        <div>
                                            <form>
                                                <fieldset v-if="added[prdct.pdtid]">
                                                    <input type="button" value="-" class="decrease"
                                                        @click="decrease(prdct.pdtid)" />
                                                    <input type="text" :value="addedproducts[prdct.pdtid].qty" readonly class="pdtext" />
                                                    <input type="button" value="+" class="increase"
                                                        @click="addedproducts[prdct.pdtid].qty++" />
                                                </fieldset>
                                                <fieldset v-if="!added[prdct.pdtid]">
                                                    <input type="button" value="Add" class="decrease"
                                                        @click="addtocart(prdct.pdtid, prdct)" />
                                                </fieldset>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                    </div>
                   
                </div>
            </div>
            <!-- <div style="padding-top: 100px;"> <img src="images/sce.png" alt=""></div> -->
            <BookingSummery :seatdetail="seatblocked" :cartdetails="addedproducts" @removeproduct="removeproduct" ref="BookSum" >
            </BookingSummery>
            <!-- end col-12 -->
            <!-- end row -->
        </div>
    </div>
    <!-- end container -->
</template>
<script>
import BookingSummery from './BookingSummery.vue';
import { URL,UPLOADS } from '@/conf';
import axios from 'axios';
export default {
    props: {
        seatblocked: null
    },
    data: () => ({
        product: null,
        category: null,
        categories: {},
        add: false,
        selectedCategory: null,
        added: {},
        products: [],
        addedproducts: {},
        selectedCategoryProducts: [],
        imgPath: process.env.BASE_URL,
        showFnB:true,
        all:true,
        uploads:UPLOADS
    }),
    components: {
        BookingSummery
    }
    , methods: {
        getproductdetails() {
            axios.get(URL + "productlist").then((response) => {
                this.product = response.data.result;
                this.selectedCategoryProducts = Object.values(response.data.result.products).flat();
                this.categories = response.data.result.category;
            });

        },
        showProducts(categoryId) {
            if(categoryId==null){
                this.selectedCategoryProducts = Object.values(this.product.products).flat();
this.add=true;  
            }
            else{
                this.add = false;
            this.all=false;
            this.selectedCategory = categoryId;
            this.selectedCategoryProducts = this.product.products[categoryId];
            }

        },
       
        addtocart(productId, product) {
            product.qty=1;
            this.addedproducts[productId]=product;
            this.added[productId] = true;
        },
        decrease(productId){
            this.addedproducts[productId].qty--;
            if(this.addedproducts[productId].qty==0){
                this.removeproduct(productId);
            }
            
        },
        removeproduct(productId) {
            delete this.addedproducts[productId];
            this.added[productId] = false;
        }
    },

    mounted() {
        this.getproductdetails();
    }
}
</script>

<style scoped>
fieldset {
  margin-bottom: 14px;
  padding-bottom: 14px;
}

fieldset,
input[type="button"] {
  border: 0;
}

input[type="button"] {
  background-color: #ec2553;
  color: #fff;
  cursor: pointer !important;
  padding: 3px 10px;
  border-radius: 3px;
}

 input[type="text"] {
  border: 1px solid #D2D2D2;
  height: 30px;
  width: 30px;
  color: #000;
  padding: 0px;
  text-align: center;
  font-size: 13px;
  margin-left: 4px;
  margin-right: 4px;
}</style>